exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "input[data-v-d9b52f08]:invalid{background-color:#ffbebe}", ""]);

// exports
